<template>
  <div class="col">
    <img v-if="img"
      :src="require(`@/assets/img/flaticon/${img}`)"
      class="img-fluid"
      style="width:65px"
      :alt="img"
    />
    <icon v-if="fa" :name="fa" scale="4" :title="title" />
    <h2 style="font-size:15px" class="mt-2">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    fa: String,
    scale: Number,
    title: String,
  },
};
</script>





// WEBPACK FOOTER //
// src/components/cService.vue